import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class ListingSyncApiService {
  constructor(
    private http: HttpClient,
    private snackbar: MatSnackBar,
  ) {}

  updateSyncStatus(url: string, ssid: string): Observable<any> {
    const body = new HttpParams().set('syncing_ssid', ssid);
    return this.http
      .post(url, body.toString(), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      })
      .pipe(
        catchError((error) => {
          if (!error.responseText || error.responseText.indexOf('NORMALIZATION_FAILED') < 0) {
            this.snackbar.open('There was an error updating your sync status', '', { duration: 5000 });
          }
          return of(null);
        }),
      );
  }

  getServiceUserIdFromSSID(ssid: string): string {
    if (ssid?.split('/')?.length > 1) {
      return ssid.split('/')[1];
    } else {
      return ssid.substring(ssid.indexOf('-') + 1);
    }
  }

  disconnectService(url: string, ssid: string, clientTags: string[]): Observable<any> {
    const body = new HttpParams()
      .set('ssid', ssid)
      .set('service_user_id', this.getServiceUserIdFromSSID(ssid))
      .set('clientTags', JSON.stringify(clientTags));
    return this.http
      .post(url, body.toString(), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      })
      .pipe(
        catchError((error) => {
          if (!error.responseText || error.responseText.indexOf('NORMALIZATION_FAILED') < 0) {
            this.snackbar.open('There was an error disconnecting your account', '', { duration: 5000 });
          }
          return EMPTY;
        }),
      );
  }
}
